import { createReducer, on } from '@ngrx/store';
import { setOverviewPlayed } from './orc.actions';


export interface State {
  overviewPlayed: boolean;
}
export const orcFeatureKey = 'orc';

export const initialState: State = {
  overviewPlayed: false,
};
export const reducer = createReducer(
  initialState,
  on(setOverviewPlayed, (state, { payload }) => ({
    ...state,
    overviewPlayed: payload,
  }))
);
